import { FC, useCallback, useMemo, useRef } from 'react';
import { useParams } from 'react-router';

import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { useModal } from 'context/ModalProvider/useModal';
import { Button } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';
import { onExporting } from 'utils/exportingExcel';

import {
  CreateContractorDriverPumpPriceModal,
  DeleteContractorDriverPumpPriceModal,
  EditPumpSalaryModal,
} from './modals';

export const ContractorDriverPumpPrice: FC = () => {
  const { id: contractorId } = useParams<{ id: string }>();
  const { showModal } = useModal();
  const employeeSalaryConfiguration: any = useMemo(() => {
    return $createStore(`/v1/ContractorDriverPumpPrice/${contractorId}`, 'id');
  }, [contractorId]);

  const refGrid = useRef<DataGrid | null>(null);
  const refreshGrid = useCallback(() => refGrid.current?.instance.refresh(), []);

  const handleClickCreate = useCallback(() => {
    showModal(<CreateContractorDriverPumpPriceModal onRefresh={refreshGrid} contractorId={Number(contractorId)} />);
  }, [showModal, refreshGrid, contractorId]);

  const handleClickEdit = useCallback(
    (id: number | string) => {
      showModal(<EditPumpSalaryModal id={Number(id)} onRefresh={refreshGrid} contractorId={Number(contractorId)} />);
    },
    [showModal, refreshGrid, contractorId],
  );

  const handleClickDelete = useCallback(
    (id: number | string) => {
      showModal(<DeleteContractorDriverPumpPriceModal id={Number(id)} onRefresh={refreshGrid} />);
    },
    [showModal, refreshGrid],
  );

  return (
    <div className="container-dev">
      <AppLayoutTop title="">
        <ClaimsProvider claimsBlock={['CanChangePumpPrice']}>
          <Button width={120} text="Создать" type="default" onClick={handleClickCreate} />
        </ClaimsProvider>
      </AppLayoutTop>

      <AppCard>
        <DataGrid
          dataSource={employeeSalaryConfiguration}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          key="id"
          ref={refGrid}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
          remoteOperations
          onExporting={onExporting}
        >
          <StateStoring enabled={true} type="localStorage" storageKey="ContractorDriverPumpPrice" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />

          <Column dataField="objectName" caption="Объект" />
          <Column dataField="dateBegin" dataType="date" caption="Дата начала" width={120} />
          <Column dataField="dateEnd" dataType="date" caption="Дата окончания" width={120} />
          <Column dataField="pumpLen" caption="Длина стрелы" />
          <Column dataField="minimalPumpDriverPrice" caption="Минимальная цена"></Column>
          <Column dataField="minimalPumpQuantity" caption="От кубов"></Column>
          <Column dataField="pumpDriverOverPrice" caption="Цена за куб"></Column>

          <Column
            dataField=""
            width={80}
            allowExporting={false}
            cellRender={({ data }) => (
              <>
                <ClaimsProvider claimsBlock={['CanChangePumpPrice']}>
                  <Button icon="edit" type="default" stylingMode="text" onClick={() => handleClickEdit(data.id)} />
                  <Button icon="trash" type="default" stylingMode="text" onClick={() => handleClickDelete(data.id)} />
                </ClaimsProvider>
              </>
            )}
          />
          <Export enabled={true} />
          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};
